var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalculatorBoatWindSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 120.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m273.79,53.52l-.19-1.06S207.5,10.99,202.54,8.54c-.16-.08-.33-.1-.51-.08l-30.73,4.11c-.54.07-1.02-.35-1.02-.9v-1.08c0-1.34-1.09-2.43-2.43-2.43h0c-1.34,0-2.43,1.09-2.43,2.43v101.48c0,.5.4.9.9.9h3.05c.5,0,.9-.4.9-.9V40.14c0-1.07,1.53-1.25,1.78-.21l3.04,12.56c.08.33.33.58.66.67l86.45,21.37.77.19.73-.3c10.23-4.19,11.07-15.49,10.08-20.89Zm-101.19-36.23l21.51-3.19c.84-.12,1.37.86.81,1.49-6.46,7.25-14.44,19.04-15.13,33.55l-.54-.13-7.4-30.61c-.12-.52.22-1.03.75-1.11Zm19.31,34.14c-.12-15.62,12.07-28.21,16.82-32.52.3-.27.74-.31,1.08-.1l13.71,8.46c.51.31.58,1.01.15,1.42-5.33,5.15-12.54,14.14-14.82,26.63-.09.51-.59.85-1.1.72l-15.15-3.75c-.4-.1-.69-.46-.7-.88Zm28.78,6.97c1.93-12.26,10.6-20.46,14.2-23.4.3-.24.72-.27,1.05-.07l16.4,10.12c.48.3.57.96.19,1.38-3.37,3.78-6.87,9.49-8.19,17.64-.08.52-.59.87-1.1.74l-21.86-5.4c-.45-.11-.76-.56-.68-1.02Zm41.54,11.12l-5.35-1.32c-.44-.11-.74-.54-.69-.99.97-7.94,4.8-12.42,7.26-14.54.3-.26.73-.3,1.07-.09l4.22,2.6c.24.15.41.41.43.69.22,3.13-.02,10.31-6.3,13.57-.2.1-.43.13-.65.07Z",
    fill: "#292a59",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m34.79,32.82c4.18,5.44,11.02,7.96,17.6,7.94s12.97-2.29,19.03-5.04c6.06-2.75,11.93-6.01,18.19-8.17,3.23-1.12,6.62-1.94,10-1.63,3.01.28,5.89,1.45,8.67,2.71,3.31,1.49,6.56,3.14,9.74,4.92,3.7,2.07,7.43,4.38,11.57,4.95,5.87.8,11.59-1.99,16.94-4.72",
    fill: "none",
    stroke: "#bf112f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m25.89,7.4c5.86-.53,11.92-.76,17.39,1.42,4.57,1.82,8.49,5.24,13.15,6.8,7.11,2.38,14.88.12,21.95-2.62s14.27-6.01,21.75-5.66",
    fill: "none",
    stroke: "#bf112f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m57.25,26.97c6.28,2.25,13.02-.66,19.23-3.13,6.66-2.66,13.48-4.85,20.3-7.01,5.09-1.61,10.29-3.2,15.59-2.97,7.35.33,14.11,4.12,21.05,6.74,6.94,2.62,15.09,3.95,21.31-.27",
    fill: "none",
    stroke: "#bf112f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculatorBoatWindSvg);
export default __webpack_public_path__ + "static/media/CalculatorBoatWindSVG.2578113103e017ae6012eb6996086009.svg";
export { ForwardRef as ReactComponent };